import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import AuthService from '../../services/AuthService';
import ROUTES from '../../components/Routes/constants';

const Logout = () => {
  const { search } = useLocation();

  useEffect(() => {
    const urlParams = new URLSearchParams(search);
    const redirectUrl = urlParams && urlParams.get('redirectUrl');

    const initiateLogout = async () => {
      const logout = await AuthService.logout();

      if (logout?.ok) {
        AuthService.handlePostLogout();
        if (redirectUrl) {
          window.location.replace(redirectUrl);
        } else {
          window.location.replace(ROUTES.TR4_LOGIN);
        }
      }
    };

    initiateLogout();
  }, [search]);

  return null;
};

export default Logout;
